import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { UsersService, type TUser } from '@/types/generated'

export const useUserStore = defineStore('userStore', () => {
  const user = ref<TUser>()
  const lawFieldOptions = computed(() => {
    const lawFields = user.value?.org.law_fields || []
    return (lawFields as string[]).map((lawField) => ({
      value: lawField,
      title: lawField
    }))
  })

  async function fetchUser() {
    try {
      const response = await UsersService.usersRetrieve({ uuid: 'current' })
      user.value = response
      return response
    } catch (error) {
      return null
    }
  }

  return {
    lawFieldOptions,
    user,
    fetchUser
  }
})
